import { WIFI_ACTIONS } from "@common/constants/actionTypes";

export const wifiIsOnline = () => {
  return { type: WIFI_ACTIONS.WIFI_ONLINE };
};

export const wifiIsOffline = () => {
  return { type: WIFI_ACTIONS.WIFI_OFFLINE };
};
